import * as React from 'react';
const DrawerStatusContext = /*#__PURE__*/React.createContext(undefined);
export default DrawerStatusContext;
//# sourceMappingURL=DrawerStatusContext.js.map